import { createFileRoute } from '@tanstack/react-router';
import { AdminTasksBoard } from '@/features/daily-tasks/components/AdminTasksBoard';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/admin-tasks-board')({
  component: AdminTasksBoardPage,
});

function AdminTasksBoardPage() {
  return (
    <PermissionGate permission={Permission.ADMIN_TASKS_BOARD}>
      <div className="h-full flex flex-col -m-4 md:-m-6">
        <div className="flex-1 min-h-0 overflow-hidden">
          <AdminTasksBoard />
        </div>
      </div>
    </PermissionGate>
  );
}
